/**
 * Escapes special regex characters in a string to make it safe for use in RegExp constructor.
 * This allows user input to be treated as literal text in find/replace operations.
 *
 * Special characters that need escaping: . * + ? ^ $ { } ( ) | [ ] \ /
 *
 * @param str - The string to escape
 * @returns The escaped string safe for use in RegExp
 *
 * @example
 * escapeRegExp('| VAV 1 |') // Returns '\\| VAV 1 \\|'
 * escapeRegExp('test.txt') // Returns 'test\\.txt'
 */
export function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function formatTagLabel(label: string): string {
  return label.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}
